import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {BulletedListSmall} from '@wix/wix-ui-icons-common/on-stage'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {TextButton, TextButtonPriority} from 'wix-ui-tpa/cssVars'
import {classes} from './accessibility-mode-button.st.css'
import {AccessibilityModeButtonProps} from './index'

export const AccessibilityModeButton = ({setShowAccessibilityMode}: AccessibilityModeButtonProps) => {
  const {t} = useTranslation()
  return (
    <div className={classes.accessibilityModeContainer}>
      <TextButton
        className={classes.textButton}
        data-hook={DH.ACCESSIBILITY_MODE_BUTTON}
        priority={TextButtonPriority.secondary}
        prefixIcon={<BulletedListSmall />}
        onClick={() => setShowAccessibilityMode(true)}
      >
        {t('seatings_selectFromList')}
      </TextButton>
    </div>
  )
}
